export const ELEVENLABS_API_KEY = 'sk_226f758f92c0b2bcc0602452ebad83c95b39eaec82f08628';

export const LIVEKIT_CONFIG = {
  SERVER_URL: 'wss://jarvis-bcps6s5p.livekit.cloud',
  API_KEY: 'APIt2wbwoz6qTRD',
  API_SECRET: 'zU0IqGuuszZHV5kFjuwhSyr92Vye05TO6OP8sggG59Y'
};

export const VOICE_PROVIDERS = {
  LIVEKIT: 'livekit',
  ELEVENLABS: 'elevenlabs',
  NATIVE: 'native'
} as const;

export const VOICE_IDS = {
  JARVIS: 'TxGEqnHWrfWFTfGW9XjX',
  RICARDO: 'pNInz6obpgDQGcFmaJgB',
};

export const VOICE_SETTINGS = {
  PROFESSIONAL: {
    stability: 0.85,
    similarity_boost: 0.75,
    style: 1.0,
    use_speaker_boost: true,
    speed: 0.95,
  },
} as const;